export default __webpack_public_path__ + "static/media/about-team-13.755c9008.jpg";